var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"laianalytics_index\"\u003E\u003Ccharts-builder\u003E\u003C\u002Fcharts-builder\u003E\u003Ccharts-list\u003E\u003C\u002Fcharts-list\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;